import * as React from "react";
import { forwardRef } from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgArrowBack = ({ title, titleId, ...props }, ref) => /* @__PURE__ */ _jsxs("svg", {
	width: 20,
	height: 20,
	viewBox: "0 -2 24 24",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	ref,
	"aria-labelledby": titleId,
	...props,
	children: [title ? /* @__PURE__ */ _jsx("title", {
		id: titleId,
		children: title
	}) : null, /* @__PURE__ */ _jsxs("g", {
		id: "icon/navigation/arrow_back_ios_24px",
		children: [
			/* @__PURE__ */ _jsx("path", {
				id: "icon/navigation/arrow_back_ios_24px_2",
				d: "M17.8341 3.8701L16.0541 2.1001L6.16406 12.0001L16.0641 21.9001L17.8341 20.1301L9.70406 12.0001L17.8341 3.8701Z",
				fill: "#fad504"
			}),
			/* @__PURE__ */ _jsx("mask", {
				id: "mask0",
				"mask-type": "alpha",
				maskUnits: "userSpaceOnUse",
				x: 6,
				y: 2,
				width: 12,
				height: 24,
				children: /* @__PURE__ */ _jsx("path", {
					id: "icon/navigation/arrow_back_ios_24px_3",
					d: "M17.8341 3.8701L16.0541 2.1001L6.16406 12.0001L16.0641 21.9001L17.8341 20.1301L9.70406 12.0001L17.8341 3.8701Z",
					fill: "white"
				})
			}),
			/* @__PURE__ */ _jsx("g", { mask: "url(#mask0)" })
		]
	})]
});
const ForwardRef = forwardRef(SvgArrowBack);
export default ForwardRef;
